var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgErrorSolid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "error",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.0286 1.94213C7.12235 1.76601 7.26224 1.6187 7.43328 1.51598C7.60432 1.41326 7.80008 1.359 7.9996 1.359C8.19912 1.359 8.39488 1.41326 8.56592 1.51598C8.73696 1.6187 8.87685 1.76601 8.9706 1.94213L14.8786 13.0231C14.9681 13.1908 15.0126 13.3787 15.0079 13.5687C15.0031 13.7587 14.9492 13.9442 14.8514 14.1072C14.7536 14.2701 14.6153 14.4049 14.4499 14.4985C14.2845 14.5921 14.0976 14.6412 13.9076 14.6411H2.0916C1.90156 14.6412 1.71474 14.5921 1.54934 14.4985C1.38393 14.4049 1.2456 14.2701 1.14781 14.1072C1.05002 13.9442 0.996115 13.7587 0.991346 13.5687C0.986578 13.3787 1.03111 13.1908 1.1206 13.0231L7.0286 1.94213ZM7.2996 6.23813H8.6996V9.74513H7.2996V6.23813ZM7.2996 11.1521H8.6996V12.5521H7.2996V11.1521Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorSolid);
export default __webpack_public_path__ + "static/media/error-solid.a14fed84a82b4feefcc0ac85f8504a75.svg";
export { ForwardRef as ReactComponent };